import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import _ from "underscore"
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

export default function Carousel() {
    const searchParams = new URLSearchParams(window.location.search)
    const [loading, setLoading] = useState(false)
    const [carouselList, setCarouselList] = useState([])
    const [modal, setModal] = useState({
        data: {},
        show: false,
        type: "",
        title: ""
    })
    const [value, setValue] = useState({
        url: "",
        isActive: false
    })

    const [file, setFile] = useState(null)
    const [preview, setpreview] = useState(null)
    const handleFileChange = (event, id) => {
        let reader = new FileReader();
        let profile = event.target.files[0];
        if (profile.type.startsWith("image/")) {
            reader.onloadend = () => {
                if (profile.size <= 10000000) {
                    setpreview(reader.result)
                    setFile(profile)
                } else {
                    Api.Alert("Max file size 10MB", "error")
                }
            };
        } else {
            Api.Alert("Uploaded file is not a valid image. Only JPG, PNG and GIF files are allowed. ", "error")
        }

        if (!_.isUndefined(profile)) {
            reader.readAsDataURL(profile);
        }
    }

    const getList = () => {
        Api.GetApi(endPoints.GETCAROUSEL).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    setCarouselList(res.data.data)
                    handleClose()
                }
            }
        })
    }

    const handleClose = () => {
        setModal({
            ...modal,
            data: {},
            show: false,
            type: "",
            title: ""
        })
        setpreview(null)
        setFile(null)
    }

    const addNew = () => {
        setModal({
            ...modal,
            show: true,
            type: "add",
            title: "Add new slide"
        })
    }
    const handleChange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value })
    }
    const toggleActiveState = (e) => {
        setValue({ ...value, [e.target.name]: e.target.checked })
    }
    const handleSubmit = () => {
        let data = new FormData();
        if (modal.type === "add") {
            if (!file) {
                return Api.Alert('Please select image', "error")
            }
            data.append("image", file)
            data.append("url", value.url || null)
            // ADDCAROUSEL
            Api.PostApi(endPoints.ADDCAROUSEL, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Added successfully!", "success")
                        getList()
                    }
                }
            })
        } else {
            if (file) {
                data.append("image", file)
            } else {
                if (modal.data.image) {
                    data.append("image", modal.data.image)
                }
            }
            data.append("url", value.url)
            data.append("isActive", value.isActive)
            // ADDCAROUSEL
            Api.PutApi(`${endPoints.GETCAROUSEL}/${modal.data._id}`, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Updated successfully!", "success")
                        getList()
                    }
                }
            })
        }
    }
    const handleConfirm = () => {
        if (modal.data && modal.data._id) {
            Api.DeleteApi(`${endPoints.GETCAROUSEL}/${modal.data._id}`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    Api.Alert(res.data.data, "success")
                    getList()
                }
            })
        }
    }
    const showModal = (data, type) => {
        if (type === "edit") {
            setValue({ ...value, "url": data.url || "", isActive: data.isActive })
            if (data.image) {
                setpreview(data.image)
            }
        }
        setModal({
            ...modal,
            data: data,
            show: true,
            type: type,
        })
    }

    const updateImagePosition = (body) => {
        Api.PutApi(endPoints.SWAPCAROUSEL, body).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                Api.Alert(res.data.data, "success")
            }
        })
    }
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedItems = [...carouselList];
        const [removed] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, removed);
        let body = {
            "carousel_ids": reorderedItems.map((data) => data._id)
        }
        console.log("reorderedItems body", body)
        updateImagePosition(body)
        setCarouselList(reorderedItems);
    };

    useEffect(() => {
        setCarouselList(carouselList)
    }, [carouselList])


    useEffect(() => {
        getList()
    }, [])

    return (
        <>
            {loading ?
                <div className="loader-line"></div> :
                <main id="main" className="main">
                    <div className="pagetitle pagetitleFilters d-flex flex-wrap  justify-content-between align-items-start">
                        <h1>Carousel Banners</h1>
                        <Button variant="primary" size='sm' className='me-2 align-items-center' onClick={addNew} >+Add New</Button>
                    </div>
                    {carouselList.length > 0 ?
                        <DndProvider backend={HTML5Backend}>
                            <div className="card">
                                <div className="card-body ">
                                    <DragDropContext onDragEnd={handleOnDragEnd}>
                                        <Droppable droppableId="droppable-inline" direction="horizontal">
                                            {(provided) => (
                                                <div
                                                    className="inline-container carousel_slider_container"
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                >
                                                    {carouselList.map((item, index) => (
                                                        <Draggable key={item._id} draggableId={item._id} index={index} >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={{
                                                                        cursor: "grab",
                                                                        ...provided.draggableProps.style,
                                                                    }} className='carousel_slide'>
                                                                    <div className='imageBtns'>
                                                                        <button className="editBtn btn btn-primary btn-sm" title="Remove image" onClick={() => showModal(item, "edit")}>
                                                                            <Icon.PencilFill />
                                                                        </button>
                                                                        <button className="deleteBtn btn btn-danger btn-sm" title="Remove image" onClick={() => showModal(item, "delete")}>
                                                                            <Icon.TrashFill />
                                                                        </button>
                                                                    </div>
                                                                    <div className='carousel_slider'>
                                                                        <div className='carousel_slider_image'>
                                                                            <img src={item.image} alt='' className='img-fluid' />
                                                                        </div>
                                                                        {item.url ?
                                                                            <div className='carousel_slider_url'>
                                                                                <span className='carousel_slider_urlIcon'>
                                                                                    <Icon.Link />
                                                                                </span>
                                                                                <a href={item.url} target='_blank'>{item.url}</a>
                                                                            </div>
                                                                            : null}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>


                                </div>
                            </div>
                        </DndProvider>
                        : null
                    }
                    <Modal show={modal.show} centered size='md' onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='h5 modalTitleCstm'> {modal.title} </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {modal.type === "add" || modal.type === "edit" ? <>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor="">Image</label>
                                        <div className='logoUpdateBox d-block'>
                                            <input type='file' className="form-control" accept="image/png, image/gif, image/jpeg" onChange={handleFileChange} />
                                            <div className='mt-2'>
                                                <div className='addnotificationPriview'>
                                                    <img src={preview && preview} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor="">Link</label>
                                        <input placeholder="" type="text" name="url" onChange={handleChange} className="form-control" value={value.url} />
                                    </div>
                                    {modal.type === "edit" ?
                                        <Form className='d-flex align-items-center '>
                                            <Form.Check
                                                className='mb-0'
                                                type="switch"
                                                name="isActive"
                                                // id={data?._id?._id}
                                                label={value?.isActive ? "Enabled" : "Disabled"}
                                                checked={value?.isActive}
                                                // value={data?._id?._id}
                                                onChange={toggleActiveState}
                                            />
                                        </Form>
                                        : null
                                    }
                                </div>
                                <div className='mt-4'>
                                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}>
                                        Save
                                    </button>
                                </div>
                            </> : null}
                            {modal.type == "delete" && <>
                                <div className='text-center mb-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to delete this slide.</h5>
                                </div>
                                <div className='text-center mt-2'>
                                    <button className='btn btn-danger btn-sm me-3' onClick={handleConfirm}> Confirm</button>
                                    <button className='btn btn-outline-danger btn-sm' onClick={handleClose} > Cancel</button>
                                </div>
                            </>}

                        </Modal.Body>
                    </Modal>

                </main>
            }
        </>
    )
}
